import { PureComponent } from "react";
import BaseSegmentComponent from "/components/segments/base-segment/base-segment-component";
import { withPreviewBaseSegment } from "contexts/preview-base-segment-context";

export default class SegmentsListComponent extends PureComponent {
  render() {
    const { segments, isUserLoggedIn, extraProps, isPreview } = this.props;
    const Component = isPreview ? withPreviewBaseSegment(BaseSegmentComponent) : BaseSegmentComponent;

    return segments.map((s, index) => {
      return (
        <Component
          extraProps={extraProps}
          key={`${s.type}_${index}`}
          segment={s}
          isUserLoggedIn={isUserLoggedIn}
          index={index}
        />
      );
    });
  }
}
